/**
 * Safely parse a tool API Response as JSON.
 *
 * Multi-provider Radar tools run on serverless functions with a maxDuration
 * cap. When a function is killed (timeout) or 5xxs, the platform returns a
 * NON-JSON body (e.g. Vercel's plain-text "An error occurred..."). Feeding that
 * to `response.json()` throws a SyntaxError ("Unexpected token 'A'..."), which
 * then leaked to users as the displayed error message on the free tool pages.
 *
 * This reads the body as text first and, when it isn't JSON, throws a clean,
 * actionable message instead. Pairs with the per-call provider timeouts in
 * `llm-providers.ts`: those make the timeout rare; this makes the failure mode
 * legible on the client when it still happens.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function parseToolJson<T = any>(response: Response): Promise<T> {
  const raw = await response.text()
  try {
    return JSON.parse(raw) as T
  } catch {
    throw new Error(
      'The service is busy right now. Please wait a moment and try again.'
    )
  }
}
